import { PollDetailPage } from '@/components/governance/poll-detail-page'

export function MemberPollDetail() {
  return <PollDetailPage basePath="/polls" />
}
